export default __webpack_public_path__ + "static/media/AntyLucy_5.fc90d559.jpg";